import { useMemo, useState } from "react";
import { useDropzone, FileRejection } from "react-dropzone";
import { faDownload, faFileImport, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { readFileAsArrayBuffer } from "../utils/fileUtils";

import Dialog from "./Dialog";
import ButtonIcon from "./ButtonIcon";

import styles from "./ToolboxImport.module.css";

const ToolboxImport: React.FC<{ onImport: (jsonString: string) => void }> = ({ onImport }) => {
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);

	const dropZoneProps = useMemo(
		() => ({
			accept: ".json",
			maxFiles: 1,
			onDropAccepted: (acceptedFiles: Array<File>) => {
				if (acceptedFiles.length > 0) {
					readFileAsArrayBuffer(acceptedFiles[0]).then(fileString => {
						const decoder = new TextDecoder("utf-8");
						onImport(decoder.decode(fileString));
					});
				}
				setOpen(false);
			},
			onDropRejected: (fileRejections: Array<FileRejection>) =>
				fileRejections.forEach(file => {
					console.log("invalid file", file.file.name, file);
				})
		}),
		[onImport]
	);
	const { getRootProps, getInputProps, isDragActive } = useDropzone(dropZoneProps);

	return (
		<>
			<ButtonIcon icon={faFileImport} onClick={() => setOpen(true)} />
			<Dialog isOpened={open} onClose={onClose} title="Import...">
				<div className={styles.dropzone} {...getRootProps()}>
					<input {...getInputProps()} />
					<span className="fa-layers fa-fw">
						<FontAwesomeIcon icon={faDownload} inverse={isDragActive} size="lg" />
						{isDragActive && (
							<FontAwesomeIcon
								icon={faPlusCircle}
								transform="shrink-6 up-10 right-10"
							/>
						)}
					</span>
					{isDragActive ? (
						<p>Drop the files here ...</p>
					) : (
						<p>Drag 'n' drop some files here, or click to select files</p>
					)}
				</div>
			</Dialog>
		</>
	);
};

export default ToolboxImport;
